import { render, staticRenderFns } from "./Zip.vue?vue&type=template&id=2561a4d0&scoped=true&"
import script from "./Zip.vue?vue&type=script&lang=js&"
export * from "./Zip.vue?vue&type=script&lang=js&"
import style0 from "./Zip.vue?vue&type=style&index=0&id=2561a4d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561a4d0",
  null
  
)

export default component.exports